import { render, staticRenderFns } from "./FileRequirementList.vue?vue&type=template&id=685f7209&scoped=true&"
import script from "./FileRequirementList.vue?vue&type=script&lang=js&"
export * from "./FileRequirementList.vue?vue&type=script&lang=js&"
import style0 from "./FileRequirementList.vue?vue&type=style&index=0&id=685f7209&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685f7209",
  null
  
)

export default component.exports